import { Button } from "primereact/button";
import CustomCheckBox from "../../components/CustomCheckBox/CustomCheckBox";
import { Combobox, ETypeOfNotification, InputDate, Modal, setNotification } from "medere-ui-framework";
import { useEffect, useState } from "react";
import { PatientRecordDTO } from "../../interface/interface";
import { useDispatch } from "react-redux";

import { ProgressBar } from "primereact/progressbar";
import ValuationReportWithMedicationWindow from "../ValuationReportWithMedicationWindow";
import { useSearchParams } from "react-router";
import './ReportGenerationSelection.scss'
import { useHealthPatientService } from "../../servicesHooks/HealthPatientService/useHealthPatientService";
import { useReportService } from "../../servicesHooks/Report/useReportService";

export enum PdfType {
    HRENTRY = 1,
    EPICRISIS = 2,
    PRESCRIPTION = 3,
    MEDICALEVOLUTION = 4,
    PARAMEDICALEVOLUTION = 5,
    SURGERY = 6,
    VITALSIGN = 7,
    BIRTH = 8,
    HOSPITALIZATIONLEVEL = 9,
    ATTACHEDDOCUMENTATION = 10,
    LABORATORY = 11,
    ADMINISTRATIVE = 12,
    MEDICATIONVALUATION = 13,
    RECIPE = 14,
    NURSINGEVOLUTION = 15
}

enum ReportType {
    HOSPITALIZATION = "Reporte de internación",
    ADMINISTRATIVE = "Reporte administrativo",
    MEDICATIONVALUATION = "Reporte de medicamentos valorizados",
}

interface PDFToGenerate {
    id: number;
    pdfName: string;
    toGenerate: boolean;
}

export type SelectablePDFToGenerate = {
    [key in keyof typeof PdfType]: PDFToGenerate;
};

const initialPDFs: SelectablePDFToGenerate = {
    HRENTRY: { id: PdfType.HRENTRY, pdfName: "Reporte de Ingreso", toGenerate: false },
    EPICRISIS: { id: PdfType.EPICRISIS, pdfName: "Epicrisis", toGenerate: false },
    PRESCRIPTION: { id: PdfType.PRESCRIPTION, pdfName: "Reporte de prescripciones", toGenerate: false },
    MEDICALEVOLUTION: { id: PdfType.MEDICALEVOLUTION, pdfName: "Evoluciones médicas", toGenerate: false },
    PARAMEDICALEVOLUTION: { id: PdfType.PARAMEDICALEVOLUTION, pdfName: "Evoluciones paramédicas", toGenerate: false },
    SURGERY: { id: PdfType.SURGERY, pdfName: "Parte quirúrgico", toGenerate: false },
    VITALSIGN: { id: PdfType.VITALSIGN, pdfName: "Signos vitales", toGenerate: false },
    BIRTH: { id: PdfType.BIRTH, pdfName: "Reporte de nacimiento", toGenerate: false },
    HOSPITALIZATIONLEVEL: { id: PdfType.HOSPITALIZATIONLEVEL, pdfName: "Nivel de hospitalización/servicio", toGenerate: false },
    ATTACHEDDOCUMENTATION: { id: PdfType.ATTACHEDDOCUMENTATION, pdfName: "Documentación anexa", toGenerate: false },
    LABORATORY: { id: PdfType.LABORATORY, pdfName: "Laboratorios", toGenerate: false },
    ADMINISTRATIVE: { id: PdfType.ADMINISTRATIVE, pdfName: "Reporte administrativo", toGenerate: false },
    MEDICATIONVALUATION: { id: PdfType.MEDICATIONVALUATION, pdfName: "Reporte de medicamentos valorizados", toGenerate: false },
    RECIPE: { id: PdfType.RECIPE, pdfName: "Recetas", toGenerate: false },
    NURSINGEVOLUTION: { id: PdfType.NURSINGEVOLUTION, pdfName: "Evoluciones de enfermería", toGenerate: false },
};

const orderedPdfKeys: Array<keyof SelectablePDFToGenerate> = [
    "HRENTRY",
    "EPICRISIS",
    "PRESCRIPTION",
    "MEDICALEVOLUTION",
    "PARAMEDICALEVOLUTION",
    "NURSINGEVOLUTION",
    "SURGERY",
    "VITALSIGN",
    "BIRTH",
    "HOSPITALIZATIONLEVEL",
    "ATTACHEDDOCUMENTATION",
    "LABORATORY",
    "ADMINISTRATIVE",
    "MEDICATIONVALUATION",
    "RECIPE",
];

export default function ReportGenerationSelection(/*params: { healthPatientServiceId: number, initialDateTime: Date, finalDateTime: Date, userId: number, siteId: number, sessionId: string, serviceEnded: boolean }*/) {
    const { getPatientByHealthPatientServiceId, isHospitalizationService } = useHealthPatientService();
    const { closeWindow, getCurrentStatus, hasMedicalValuationPermission, printHospitalizationPDFs } = useReportService();
    //const { healthPatientServiceId, initialDateTime, finalDateTime, userId, siteId, sessionId, serviceEnded } = params

    const [searchParams] = useSearchParams();
    const healthPatientServiceId: number = Number(searchParams.get('healthPatientServiceID'));
    //const siteId: number = Number(searchParams.get('siteID'));
    //const userId: number = Number(searchParams.get('userID'));
    const sessionId: string | null = searchParams.get('sessionID');
    const initialDateTime: Date = new Date(searchParams.get('initialDateTime') || '');
    const finalDateTime: Date = new Date(searchParams.get('finalDateTime') || '');
    //const serviceEnded: boolean | null = searchParams.get('showProfessionals') === 'true';

    const dispatch = useDispatch();
    const [patient, setPatient] = useState<PatientRecordDTO>();
    const [fromDate, setFromDate] = useState(setStartOfDay(initialDateTime));
    const [toDate, setToDate] = useState(setEndOfDay(finalDateTime));
    const [selectedPDFs, setSelectedPDFs] = useState<SelectablePDFToGenerate>(initialPDFs);
    const [includeHoursEvolution, setIncludeHoursEvolution] = useState(searchParams.get('includeHoursEvolution') === 'true');
    const [selectedReportType, setSelectedReportType] = useState("");
    const [hasPermission, setHasPermission] = useState(false)
    const [isHospitalization, setIsHospitalization] = useState(false)
    const [modalMedicationValuation, setModalMedicationValuation] = useState(false)

    const [genId, setGenId] = useState(null);
    const [status, setStatus] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    const displayCheckboxes = selectedReportType !== ReportType.ADMINISTRATIVE && selectedReportType !== ReportType.MEDICATIONVALUATION;
    const displayIncludeHoursEvolution = selectedPDFs.MEDICALEVOLUTION.toGenerate || selectedPDFs.PARAMEDICALEVOLUTION.toGenerate || selectedPDFs.NURSINGEVOLUTION.toGenerate;

    useEffect(() => {
        initCombo()

        hasMedicalValuationPermission()
            .then((res) => {
                setHasPermission(res)
            })
            .catch(() => {
                dispatch(setNotification({ title: 'No se pudieron verificar sus permisos', icon: "pi-times", typeOfNotification: ETypeOfNotification.WARNING }));
            })

        isHospitalizationService(healthPatientServiceId)
            .then((res) => {
                setIsHospitalization(res)
            })
            .catch((e) => {
                console.error("Ocurrió un error al traer el tipo de servicio", e)
            })

        getPatientByHealthPatientServiceId(healthPatientServiceId)
            .then((res) => {
                setPatient(res)
            })
            .catch(() => {
                dispatch(setNotification({ title: 'No se pudieron traer los datos del paciente', icon: "pi-times", typeOfNotification: ETypeOfNotification.WARNING }));
            })
    }, [])

    useEffect(() => {
        if (patient && !isHospitalization) { //patient se carga despues de isHospitalization, por lo que evita entrar al if cuando recien se carga la vista, evitando comportamientos indeseados
            setSelectedPDFs(prev => ({
                ...prev,
                HRENTRY: { ...prev.HRENTRY, toGenerate: false },
                EPICRISIS: { ...prev.EPICRISIS, toGenerate: false },
            }));
        }
    }, [isHospitalization]);

    function setStartOfDay(date: Date) {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        return d;
    }

    function setEndOfDay(date: Date) {
        const d = new Date(date);
        d.setHours(23, 59, 59, 999);
        return d;
    }


    const reportOptions = hasPermission ? [
        {
            label: ReportType.HOSPITALIZATION,
            pdfs: {
                ...Object.keys(initialPDFs).reduce((acc, key) => {
                    return {
                        ...acc,
                        [key]: {
                            ...initialPDFs[key as keyof SelectablePDFToGenerate],
                            toGenerate: true,
                        },
                    };
                }, {} as SelectablePDFToGenerate),
                LABORATORY: { ...initialPDFs.LABORATORY, toGenerate: false },
                RECIPE: { ...initialPDFs.RECIPE, toGenerate: false },
                ADMINISTRATIVE: { ...initialPDFs.ADMINISTRATIVE, toGenerate: false },
                MEDICATIONVALUATION: { ...initialPDFs.MEDICATIONVALUATION, toGenerate: false },
            }
        },
        {
            label: ReportType.ADMINISTRATIVE,
            pdfs: {
                ...Object.keys(initialPDFs).reduce((acc, key) => {
                    return {
                        ...acc,
                        [key]: {
                            ...initialPDFs[key as keyof SelectablePDFToGenerate],
                            toGenerate: false,
                        },
                    };
                }, {} as SelectablePDFToGenerate),
                ADMINISTRATIVE: { ...initialPDFs.ADMINISTRATIVE, toGenerate: true },
            },
        },
        {
            label: ReportType.MEDICATIONVALUATION,
            pdfs: {
                ...Object.keys(initialPDFs).reduce((acc, key) => {
                    return {
                        ...acc,
                        [key]: {
                            ...initialPDFs[key as keyof SelectablePDFToGenerate],
                            toGenerate: false,
                        },
                    };
                }, {} as SelectablePDFToGenerate),
                MEDICATIONVALUATION: { ...initialPDFs.MEDICATIONVALUATION, toGenerate: true },
            },
        },
    ] :
        [
            {
                label: ReportType.HOSPITALIZATION,
                pdfs: {
                    ...Object.keys(initialPDFs).reduce((acc, key) => {
                        return {
                            ...acc,
                            [key]: {
                                ...initialPDFs[key as keyof SelectablePDFToGenerate],
                                toGenerate: true,
                            },
                        };
                    }, {} as SelectablePDFToGenerate),
                    LABORATORY: { ...initialPDFs.LABORATORY, toGenerate: false },
                    RECIPE: { ...initialPDFs.RECIPE, toGenerate: false },
                    ADMINISTRATIVE: { ...initialPDFs.ADMINISTRATIVE, toGenerate: false },
                    MEDICATIONVALUATION: { ...initialPDFs.MEDICATIONVALUATION, toGenerate: false },
                }
            },
            {
                label: ReportType.ADMINISTRATIVE,
                pdfs: {
                    ...Object.keys(initialPDFs).reduce((acc, key) => {
                        return {
                            ...acc,
                            [key]: {
                                ...initialPDFs[key as keyof SelectablePDFToGenerate],
                                toGenerate: false,
                            },
                        };
                    }, {} as SelectablePDFToGenerate),
                    ADMINISTRATIVE: { ...initialPDFs.ADMINISTRATIVE, toGenerate: true },
                },
            }
        ];

    const initCombo = () => {
        setSelectedReportType(ReportType.HOSPITALIZATION)
        const defaultSelectedPDFs: SelectablePDFToGenerate = Object.keys(initialPDFs).reduce(
            (acc, key) => ({
                ...acc,
                [key]: {
                    ...initialPDFs[key as keyof SelectablePDFToGenerate],
                    toGenerate: true,
                },
            }),
            {} as SelectablePDFToGenerate
        );
        defaultSelectedPDFs.LABORATORY.toGenerate = false;
        defaultSelectedPDFs.RECIPE.toGenerate = false;
        defaultSelectedPDFs.ADMINISTRATIVE.toGenerate = false;
        defaultSelectedPDFs.MEDICATIONVALUATION.toGenerate = false;
        setSelectedPDFs(defaultSelectedPDFs)
    }

    const handleReportTypeChange = (newValue: string) => {
        const selectedOption = reportOptions.find((opt) => opt.label === newValue);
        if (selectedOption) {
            const updated = JSON.parse(JSON.stringify(selectedOption.pdfs));
            setSelectedPDFs(updated);
        }
        setSelectedReportType(newValue);
    };

    const handleCheckboxChange = (key: keyof SelectablePDFToGenerate) => {
        setSelectedPDFs((prev) => ({
            ...prev,
            [key]: { ...prev[key], toGenerate: !prev[key].toGenerate },
        }));
    };

    const pollStatus = (id: number) => {
        const interval = setInterval(() => {
            getCurrentStatus(id)
                .then((res) => {
                    setStatus(res);
                    if (res === "FINALIZADO" || res === "ERROR") {
                        clearInterval(interval);
                        setLoading(false);
                        if (res === "ERROR") {
                            dispatch(setNotification({ title: 'No se ha podido generar el pdf', icon: "pi-times", typeOfNotification: ETypeOfNotification.ERROR }));
                        }
                    }
                });
        }, 2000);
    }

    const closeTheWindow = () => {
        if (sessionId) {
            window.parent.postMessage(
                {
                    type: 'MEDERE_CLOSE_REPORT_GENERATION_WINDOW',
                    sessionId,
                },
                window.location.origin
            );
        }
        setLoading(false);
    }

    const handleGeneratePDF = () => {
        if (selectedReportType === ReportType.MEDICATIONVALUATION)
            setModalMedicationValuation(true)
        else {
            setLoading(true);
            printHospitalizationPDFs(selectedPDFs, healthPatientServiceId, fromDate, toDate, sessionId, includeHoursEvolution)
            .then((res) => {
                setGenId(res)
                pollStatus(res)
            })
            .catch(() => {
                setLoading(false)
                dispatch(setNotification({ title: 'No se ha podido generar el pdf', icon: "pi-times", typeOfNotification: ETypeOfNotification.ERROR }));
            })
        }
    }

    return (
        <div className="p-4">
            <h2 style={{ fontSize: '21px', fontWeight: 'bold' }} className="title">Reporte de internación</h2>
            <p style={{ color: '#183462', fontSize: '14px' }} className="pt-1"><strong>{"Paciente: " + (patient?.firstname ?? '') + " " + (patient?.lastname ?? '') + " - DNI: " + (patient?.document ?? '')}</strong></p>

            <hr style={{ borderTop: '1px solid #DEE2E6', marginTop: '12px', marginBottom: '8px' }} />

            {loading ?
                <div>
                    <h2 style={{ fontSize: '21px' }} className="mb-2">Generando documento...</h2>
                    <div className="border-grey" style={{ padding: '16px' }}>
                        <ProgressBar mode="indeterminate" style={{ height: '16px' }}></ProgressBar>
                    </div>
                </div>
                :
                <div>
                    <div className="report-filters">
                        <Combobox
                            className="flex-grow"
                            style={{ maxWidth: '460px' }}
                            label="Tipo de reporte"
                            optionLabel="label"
                            placeholder="Seleccionar"
                            getItems={() => Promise.resolve(reportOptions)}
                            reLoadItemsValue={hasPermission}
                            value={selectedReportType}
                            setValue={(e: any) => handleReportTypeChange(e.label)}
                        />
                        <div className="date-group">
                            <InputDate label="Fecha desde" value={fromDate} onChange={(e: any) => setFromDate(setStartOfDay(e.value))} />
                            <InputDate label="hasta" value={toDate} onChange={(e: any) => {
                                const selectedDate = new Date(e.value);
                                setToDate(setEndOfDay(selectedDate));
                            }} />
                        </div>
                    </div>

                    {displayCheckboxes && (
                        <div style={{ border: "1px solid #ccc", borderRadius: '6px', padding: "10px", marginTop: "10px" }}>
                            <p style={{ color: '#6C757D', marginBottom: '4px' }}>Contiene:</p>
                            <div className="report-grid">
                                {orderedPdfKeys
                                .map((key) => ({ key, pdf: selectedPDFs[key] }))
                                .filter(({ pdf }) =>
                                    !(
                                        (selectedReportType === ReportType.HOSPITALIZATION &&
                                            (pdf.id === PdfType.ADMINISTRATIVE || pdf.id === PdfType.MEDICATIONVALUATION)) ||
                                            (!isHospitalization && (pdf.id === PdfType.HRENTRY || pdf.id === PdfType.EPICRISIS))
                                    ))
                                .map(({ key, pdf }) => (
                                    <label key={pdf.id} style={{ display: "flex", alignItems: "center", gap: "5px", color: '#495057', marginBottom: '8px' }}>
                                        <CustomCheckBox
                                            checked={pdf.toGenerate}
                                            onChange={() => handleCheckboxChange(key)}
                                        />
                                        {pdf.pdfName}
                                    </label>
                                ))}
                            </div>
                            {displayIncludeHoursEvolution && (
                                <>
                                    <hr style={{ borderTop: '1px solid #DEE2E6', marginTop: '4px', marginBottom: '8px' }} />
                                    <label style={{ display: "flex", alignItems: "center", gap: "5px", color: '#495057' }}>
                                        <CustomCheckBox
                                            checked={includeHoursEvolution}
                                            onChange={() => setIncludeHoursEvolution(prev => !prev)}
                                        />
                                        Hora de registro
                                    </label>
                                </>
                            )}
                        </div>
                    )}

                    {selectedReportType === ReportType.ADMINISTRATIVE && (
                        <div style={{ border: "1px solid #ccc", borderRadius: '6px', padding: "10px", marginTop: "10px" }}>
                            <p style={{ color: '#6C757D', marginBottom: '4px' }}>Contiene:</p>
                            <div>
                                Indicaciones prescriptas por profesionales y aplicaciones realizadas.
                            </div>
                        </div>
                    )}

                    <div style={{ display: "flex", justifySelf: 'right', gap: '8px', marginTop: "20px" }}>
                        {<Button className="buttonMain2 min-width-160" type="button" label="Cancelar" onClick={() => { closeTheWindow() }} />}
                        <Button className="buttonMain min-width-160" label="Generar" onClick={() => handleGeneratePDF()} />
                    </div>
                </div>
            }

            <Modal
                visible={modalMedicationValuation}
                setVisible={setModalMedicationValuation}
                className="h-full"
                width="w-2xlarge"
            >
                <ValuationReportWithMedicationWindow
                    healthPatientServiceId={healthPatientServiceId}
                    initialDateTime={fromDate}
                    finalDateTime={toDate}
                    name={patient ? patient.firstname + " " + patient.lastname : null}
                    serviceEnded={searchParams.get('showProfessionals') === 'true'}
                />
            </Modal>

        </div>
    );
}
